"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MhUpload", {
  enumerable: true,
  get: function get() {
    return _upload.MhUpload;
  }
});
Object.defineProperty(exports, "fileToken", {
  enumerable: true,
  get: function get() {
    return _utils.fileToken;
  }
});
Object.defineProperty(exports, "setHttp", {
  enumerable: true,
  get: function get() {
    return _http.setHttp;
  }
});
Object.defineProperty(exports, "setFileDomain", {
  enumerable: true,
  get: function get() {
    return _http.setFileDomain;
  }
});
Object.defineProperty(exports, "setTokenUpdate", {
  enumerable: true,
  get: function get() {
    return _config.setTokenUpdate;
  }
});

var _vue = _interopRequireDefault(require("vue"));

var Antd = _interopRequireWildcard(require("ant-design-vue"));

require("ant-design-vue/dist/antd.less");

var _select = require("./select");

require("./style/index.less");

var _childForm = require("./childForm");

var _datePicker = require("./datePicker");

var _upload = require("./upload");

var _cascader = require("./cascader");

var _rangePicker = require("./datePicker/rangePicker");

var _infinityTable = require("./table/infinityTable");

var _utils = require("./utils");

var _http = require("./utils/http");

var _monthPicker = require("./datePicker/monthPicker");

var _Simditor = require("./simditor/Simditor");

var _config = require("./simditor/config");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextArea = Antd.Input.TextArea;
var Option = Antd.Select.Option;
var CheckboxGroup = Antd.Checkbox.Group;
var RadioGroup = Antd.Radio.Group;

_vue.default.use(Antd);

_vue.default.component('mh-input', Antd.Input);

_vue.default.component('mh-textarea', TextArea);

_vue.default.component('mh-input-number', Antd.InputNumber);

_vue.default.component('mh-select', _select.MhSelect);

_vue.default.component('mh-option', Option);

_vue.default.component('mh-cascader', _cascader.MhCascader);

_vue.default.component('mh-checkbox', Antd.Checkbox);

_vue.default.component('mh-checkbox-group', CheckboxGroup);

_vue.default.component('mh-radio', Antd.Radio);

_vue.default.component('mh-radio-group', RadioGroup);

_vue.default.component('mh-date-picker', _datePicker.MhDatePicker);

_vue.default.component('mh-month-picker', _monthPicker.MhMonthPicker);

_vue.default.component('mh-range-picker', _rangePicker.MhRangePicker);

_vue.default.component('mh-button', Antd.Button);

_vue.default.component('mh-divider', Antd.Divider);

_vue.default.component('mh-upload', _upload.MhUpload);

_vue.default.component('mh-child-form', _childForm.ChildForm);

_vue.default.component('mh-infinity-table', _infinityTable.MhInfinityTable);

_vue.default.component('mh-quill-editor', _Simditor.SimditorVue);